import { assertValue } from '@libs/utils';

import type { PriceMaskBoundaries } from '../models';
import { PriceMaskType } from '../models';

export function getPriceMaskType(
  priceMaskBoundaries: PriceMaskBoundaries,
  price: number
): PriceMaskType {
  if (price < priceMaskBoundaries.cheap) {
    return PriceMaskType.Cheap;
  }
  if (price < priceMaskBoundaries.moderate) {
    return PriceMaskType.Moderate;
  }
  return PriceMaskType.Expensive;
}

export function calculatePriceMaskBoundries(
  prices: number[]
): PriceMaskBoundaries {
  if (!prices.length) {
    return { cheap: 0, moderate: 0 };
  }
  const oneSixth = 0.1666;
  const sortedPrices = [...prices].sort((a, b) => a - b);
  const middleIndex = Math.floor(sortedPrices.length / 2);
  const marginCount = Math.floor(prices.length * oneSixth);
  const cheap = sortedPrices[Math.max(0, middleIndex - marginCount)];
  const moderate =
    sortedPrices[Math.min(sortedPrices.length - 1, middleIndex + marginCount)];

  assertValue(
    cheap,
    'priceCalendarLogic.ts > calculatePriceMaskBoundries > cheap'
  );
  assertValue(
    moderate,
    'priceCalendarLogic.ts > calculatePriceMaskBoundries > moderate'
  );

  return {
    cheap,
    moderate,
  };
}
